import React from "react";
import { type BuildAndBuyDispatchType, useBnbSelector } from "../../../redux/store";
import * as Styles from "./styles/Summary";
import * as Flex from "../../../../../../common-deprecated/styles/v2/lexus/globals/Flex";
import { calculateWinterWheelPrice, getCarDescription } from "../../../utils/typedUtils";
import { removeWinterWheel } from "../../../redux/actions/BasketActions";
import { BnbLabel, getBnbLabel } from "../../../utils/labels";
import { NavStep } from "../../../../shared-logic/utils/Navigation";
import SummaryRow from "./SummaryRow";
import SummaryRowWheel from "./SummaryRowWheel";
import useSummaryPack from "../../../hooks/shared/packs/useSummaryPack";
import Icon from "../../../../../../common-deprecated/styles/v2/lexus/globals/Icon";
import * as Text from "../../../../../../common-deprecated/styles/v2/lexus/utilities/Text";
import { LineClamp } from "../../../../../../common-deprecated/styles/v2/lexus/utilities/Lineclamp";
import SummaryCtas from "./SummaryCtas";
import BasketConfigCode from "../common/basket/summary/BasketConfigCode";
import SummaryTotalPanel from "./SummaryTotalPanel";
import { isIsrael, isRTL } from "../../../../../../common-deprecated/settings/utils/commonSettingUtils";
import Pack from "../step-customize/main-content/Pack";
import { trackChangeCustomisation, trackCustomizeConfigItem } from "../../../utils/tracking";
import { isPassiveSummary } from "../../../utils/settings/bnbSettingUtils";
import useStepUrl from "../../../hooks/shared/actions/useStepUrl";
import ButtonWithIcon from "../../../../../../common-deprecated/components/aem/lexus/button/ButtonWithIcon";
import { useDispatch } from "../../../../../../shared-logic/redux/store";

// TODO: When the refresh-icon is available in the icon-font
// then remove this SVG icon and use the icon from the icon-font

const SummaryDetails = (): JSX.Element => {
    const dispatch = useDispatch<BuildAndBuyDispatchType>();
    const car = useBnbSelector((state) => state.car);
    const basket = useBnbSelector((state) => state.basket);
    const commonSettings = useBnbSelector((state) => state.commonSettings);
    const bnbSettings = useBnbSelector((state) => state.bnbSettings);
    const isRTLSetting = isRTL(commonSettings);

    // Hides change grade and change customization buttons and all possibilities to remove items
    const passiveSummary = isPassiveSummary(commonSettings);

    const { packs } = useSummaryPack();
    const { colour, wheel, winterWheel, upholstery } = basket;

    const customizeUrl = useStepUrl(NavStep.Customize).href;

    return (
        <>
            <Styles.DetailsWrapper id="or-build-summary-details">
                <SummaryCtas />
                {!bnbSettings.hideTyCode && <BasketConfigCode />}
                <SummaryTotalPanel />
            </Styles.DetailsWrapper>
            <Styles.Header>
                <Styles.Title>
                    <LineClamp>
                        <BnbLabel label="basketYourModel" params={{ name: car.model.webtitleSectionName }} />
                    </LineClamp>
                </Styles.Title>
                {!passiveSummary && (
                    <ButtonWithIcon href={customizeUrl} onClick={trackChangeCustomisation}>
                        <Text.IconButton>
                            <BnbLabel label="changeCustomisation" />
                        </Text.IconButton>
                        <Icon variant={isRTLSetting ? "arrowLeft" : "arrowRight"} />
                    </ButtonWithIcon>
                )}
            </Styles.Header>

            <SummaryRow
                text={getCarDescription(car)}
                price={!isIsrael(commonSettings.culture.name) ? car.price : undefined}
            />

            <Flex.Col justifyContent="space-between" display="flex" alignItems="center" p={0} mt={5}>
                <Styles.Title>
                    <LineClamp>
                        <BnbLabel label="yourCustomisation" params={{ name: car.model.webtitleSectionName }} />
                    </LineClamp>
                </Styles.Title>
            </Flex.Col>

            <SummaryRow text={colour.name} price={colour.price} itemId={colour.id} />
            <SummaryRowWheel text={wheel.name} price={wheel.price} />
            {winterWheel && (
                <SummaryRow
                    text={winterWheel.name}
                    popoverContent={
                        winterWheel.installTheWheels &&
                        !winterWheel.installationCost &&
                        getBnbLabel({ commonSettings, bnbSettings }, "winterWheelsModalExcludingInstallationCosts")
                    }
                    price={calculateWinterWheelPrice(winterWheel)}
                    itemId={winterWheel.id}
                    onRemove={
                        passiveSummary
                            ? undefined
                            : () => {
                                  trackCustomizeConfigItem(NavStep.Summary, "remove-winter-set");
                                  dispatch(removeWinterWheel());
                              }
                    }
                />
            )}
            <SummaryRow text={upholstery.name} price={upholstery.price} itemId={upholstery.id} />

            {/* Packs and equipment */}
            {packs.length ? (
                <>
                    <Styles.Title pb={2} pt={3}>
                        <BnbLabel label="optionalPacks" />
                    </Styles.Title>
                    {packs.map((pack) => (
                        <Pack pack={pack} showImage packIndex={1} />
                    ))}
                </>
            ) : null}
        </>
    );
};

export default SummaryDetails;
